import { format } from 'date-fns';
import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter, Redirect } from 'react-router';
import * as PropTypes from 'prop-types'; 

import { IHistory } from '../../../interfaces';
import { parseJwt } from '../../../services/loginService';
import { submitMonthlyForm, getMonthlyFormQuestions } from '../../../services/monthlyFormService';
import { dispatch, marshallAnswers, checkAnswerForYesOrNo, getPageTitle } from '../../../utils/generalUtils';
import { BasePage } from '../../reusableComponents/BasePage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Async } from '../../reusableComponents/Async';
import { Loader } from '../../reusableComponents/Loader';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { QuestionModel } from '../../../model/QuestionModel';
import { MonthlySpillLogs } from '../../../constants/generals'; 
import { RenderQuestion } from '../../reusableComponents/FormComponents/RenderQuestion';
import { MonthlyFormModel } from '../../../model/MonthlyFormModel'; 

export interface IMonthlySpillLogsFormProps {
    date: string;
    plantId: string;
    userUID: string;
    formId: string;
    type: string;
    userName: string;
    history: IHistory;
    questions: QuestionModel[];
    formInstance: MonthlyFormModel;
    form;
}

export interface IMonthlySpillLogsFormState {
    date: string;
    answers: Object;
}

export class MonthlySpillLogsFormImpl extends
    React.PureComponent<IMonthlySpillLogsFormProps, IMonthlySpillLogsFormState> {
    constructor(props: IMonthlySpillLogsFormProps) {
        super(props);
        this.state = {
            date: props.date, answers: {}
        };
    }
    loadDefaultValues = () => {
        const answers = [];
        if (this.props.formId) {
            this.props.questions.forEach(instance => {
                answers.push({
                    answer: instance.props.answer,
                    quesName: instance.props.question
                });
                dispatch(actions.change(`forms.monthlySpillLogs.${instance.props.quesNum}`,
                    checkAnswerForYesOrNo(instance.props.answer)));
            });
        }
    }
    loadValues = () => {
        const answers = [];
        this.loadDefaultValues();
         dispatch(actions.change('forms.monthlySpillLogs.1', format(new Date(this.props.date), 'MM/DD/YYYY')));
         dispatch(actions.change('forms.monthlySpillLogs.2', this.props.userName));
    }

    refs: {
        images: ImageUpload;
    };
    getChildContext() {
        return { formModel: 'forms.monthlySpillLogs' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };
    promise = async () => {
        await getMonthlyFormQuestions(this.props.type, this.props.formId);
    }

    handleFormSubmit = (values) => {
        const answer = marshallAnswers(values,'MonthlySpillLogs');
        answer.push({
            quesNum: answer.length + 1,
            answer: format(new Date(), 'hh:mm A')
        });
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'MonthlySpillLogs',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            followUp_form: 0,
            ImageUrls: [],
            DeletedImages : this.props.form.monthlySpillLogs.deletedImages || [],
            SignatureUrls: [],
            AssociatedTo: null
        };
        return submitMonthlyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    renderContent = () => {
        return <Form
            loadDefaultValues={this.loadValues}
            model="forms.monthlySpillLogs"
            onSubmit={this.handleFormSubmit}>
             {MonthlySpillLogs && MonthlySpillLogs.map((quesData, index) => (
                <RenderQuestion
                formId={this.props.formId}
                key={index}
                uniqueValue={index}
                quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
                question={quesData.Question}
                questionType={quesData.Questiontype}
                model="monthlySpillLogs"
                CommentQuestionNum={quesData.CommentQuestionNum ? quesData.CommentQuestionNum : null}
                customLabel={' '}
            />
            ))
            }
            <ImageUpload
                ref="images"
                multi={true}
                label="Select Images to Upload:" 
                defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
            />
            <FormFooter />
        </Form>;
    }
    render() { 
        let pageTitle = `${getPageTitle(this.props.type, 'monthly', this.props.date, 'inspection')} `;
        return <BasePage
            pageTitle={pageTitle}>
            <div style={{ fontSize: '16px', textAlign: 'center', padding: '10px' }} >
                <span>Date:</span>&nbsp;&nbsp;
            <span><strong>{this.props.date}</strong></span>
            </div>
            <Async
                identifier="USTSpillForm"
                promise={this.promise}
                content={this.renderContent()}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
            />
        </BasePage >;
    }
}

export function mapStateToProps(state, ownProps) {
    const date = ownProps.match.params.date;
    const firstName = parseJwt(state.login.get('token')).First_Name;
    const lastName = parseJwt(state.login.get('token')).Last_Name;
    const formId = ownProps.match.params.formId;
    const questions = QuestionModel.getAllByType('MonthlySpillLogs');
    const formInstance = MonthlyFormModel.get(ownProps.match.params.formId); 
    return {
        plantId: ownProps.match.params.plantId,
        userUID: state.login.get('UniqueId'), date,
        userName: `${firstName} ${lastName}`,
        type: 'MonthlySpillLogs', formId, questions,form: state.forms, formInstance
    };
}

export const MonthlySpillLogForm =
    withRouter(connect<any, any, IMonthlySpillLogsFormProps>(mapStateToProps)(MonthlySpillLogsFormImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/MonthlyForm/MonthlySpillLogForm.tsx